import { render, staticRenderFns } from "./Opportunities.vue?vue&type=template&id=4d9fff0b&scoped=true&"
import script from "./Opportunities.vue?vue&type=script&lang=js&"
export * from "./Opportunities.vue?vue&type=script&lang=js&"
import style0 from "./Opportunities.vue?vue&type=style&index=0&id=4d9fff0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9fff0b",
  null
  
)

export default component.exports